module.exports = __webpack_public_path__ + "dc771bb2014eab6a787f79868ee74a8f.png";